/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/NotificationReport', 'model/NotificationReportPaginationSlice', 'model/NotificationFilter'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/NotificationReport'), require('../model/NotificationReportPaginationSlice'), require('../model/NotificationFilter'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.NotificationReportApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.NotificationReport, root.ForStractionServiceApi.NotificationReportPaginationSlice, root.ForStractionServiceApi.NotificationFilter);
  }
}(this, function(ApiClient, NotificationReport, NotificationReportPaginationSlice, NotificationFilter) {
  'use strict';

  /**
   * NotificationReport service.
   * @module api/NotificationReportApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new NotificationReportApi. 
   * @alias module:api/NotificationReportApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the notificationReportCreateUserContentLoginURLGet operation.
     * @callback module:api/NotificationReportApi~notificationReportCreateUserContentLoginURLGetCallback
     * @param {String} error Error message, if any.
     * @param {'String'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * createUserContentLoginURL
     * @param {String} _4SAPIAppID 
     * @param {Integer} notificationTypeID 
     * @param {String} loginTarget 
     * @param {module:api/NotificationReportApi~notificationReportCreateUserContentLoginURLGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'String'}
     */
    this.notificationReportCreateUserContentLoginURLGet = function(_4SAPIAppID, notificationTypeID, loginTarget, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling notificationReportCreateUserContentLoginURLGet";
      }

      // verify the required parameter 'notificationTypeID' is set
      if (notificationTypeID == undefined || notificationTypeID == null) {
        throw "Missing the required parameter 'notificationTypeID' when calling notificationReportCreateUserContentLoginURLGet";
      }

      // verify the required parameter 'loginTarget' is set
      if (loginTarget == undefined || loginTarget == null) {
        throw "Missing the required parameter 'loginTarget' when calling notificationReportCreateUserContentLoginURLGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'notificationTypeID': notificationTypeID,
        'loginTarget': loginTarget
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'String';

      return this.apiClient.callApi(
        '/NotificationReport/createUserContentLoginURL', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the notificationReportLoadBetweenGet operation.
     * @callback module:api/NotificationReportApi~notificationReportLoadBetweenGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/NotificationReport>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadBetween
     * @param {String} _4SAPIAppID 
     * @param {Object} opts Optional parameters
     * @param {Date} opts.startDate 
     * @param {Date} opts.endDate 
     * @param {module:api/NotificationReportApi~notificationReportLoadBetweenGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/NotificationReport>}
     */
    this.notificationReportLoadBetweenGet = function(_4SAPIAppID, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling notificationReportLoadBetweenGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'startDate': opts['startDate'],
        'endDate': opts['endDate']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [NotificationReport];

      return this.apiClient.callApi(
        '/NotificationReport/loadBetween', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the notificationReportLoadSeenGet operation.
     * @callback module:api/NotificationReportApi~notificationReportLoadSeenGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/NotificationReport>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadSeen
     * @param {String} _4SAPIAppID 
     * @param {module:api/NotificationReportApi~notificationReportLoadSeenGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/NotificationReport>}
     */
    this.notificationReportLoadSeenGet = function(_4SAPIAppID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling notificationReportLoadSeenGet";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [NotificationReport];

      return this.apiClient.callApi(
        '/NotificationReport/loadSeen', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the notificationReportLoadSliceGet operation.
     * @callback module:api/NotificationReportApi~notificationReportLoadSliceGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/NotificationReportPaginationSlice} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadSlice
     * @param {String} _4SAPIAppID 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.startID  (default to 0)
     * @param {Integer} opts.maxCount  (default to 0)
     * @param {Integer} opts.slicingOrder  (default to 0)
     * @param {module:api/NotificationReportApi~notificationReportLoadSliceGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/NotificationReportPaginationSlice}
     */
    this.notificationReportLoadSliceGet = function(_4SAPIAppID, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling notificationReportLoadSliceGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'startID': opts['startID'],
        'maxCount': opts['maxCount'],
        'slicingOrder': opts['slicingOrder']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = NotificationReportPaginationSlice;

      return this.apiClient.callApi(
        '/NotificationReport/loadSlice', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the notificationReportLoadUnseenGet operation.
     * @callback module:api/NotificationReportApi~notificationReportLoadUnseenGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/NotificationReport>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadUnseen
     * @param {String} _4SAPIAppID 
     * @param {module:api/NotificationReportApi~notificationReportLoadUnseenGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/NotificationReport>}
     */
    this.notificationReportLoadUnseenGet = function(_4SAPIAppID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling notificationReportLoadUnseenGet";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [NotificationReport];

      return this.apiClient.callApi(
        '/NotificationReport/loadUnseen', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the notificationReportSearchSlicePut operation.
     * @callback module:api/NotificationReportApi~notificationReportSearchSlicePutCallback
     * @param {String} error Error message, if any.
     * @param {module:model/NotificationReportPaginationSlice} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * searchSlice
     * @param {String} _4SAPIAppID 
     * @param {module:model/NotificationFilter} body 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.startID  (default to 0)
     * @param {Integer} opts.maxCount  (default to 0)
     * @param {Integer} opts.slicingOrder  (default to 0)
     * @param {module:api/NotificationReportApi~notificationReportSearchSlicePutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/NotificationReportPaginationSlice}
     */
    this.notificationReportSearchSlicePut = function(_4SAPIAppID, body, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling notificationReportSearchSlicePut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling notificationReportSearchSlicePut";
      }


      var pathParams = {
      };
      var queryParams = {
        'startID': opts['startID'],
        'maxCount': opts['maxCount'],
        'slicingOrder': opts['slicingOrder']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = NotificationReportPaginationSlice;

      return this.apiClient.callApi(
        '/NotificationReport/searchSlice', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the notificationReportTouchAllGet operation.
     * @callback module:api/NotificationReportApi~notificationReportTouchAllGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * touchAll
     * @param {String} _4SAPIAppID 
     * @param {module:api/NotificationReportApi~notificationReportTouchAllGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.notificationReportTouchAllGet = function(_4SAPIAppID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling notificationReportTouchAllGet";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/NotificationReport/touchAll', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
